<template>
  <div
    class="bg-slate-600 rounded-lg transition-all duration-500 ease-out cursor-pointer hover:bg-slate-500 transform relative overflow-hidden"
    :class="{
      'col-span-3': isExpanded,
      'col-span-1': !isExpanded
    }"
    @mouseenter="$emit('mouseenter', index)"
    @mouseleave="$emit('mouseleave')"
  >
    <!-- Background image -->
    <div
      class="absolute inset-0 bg-cover bg-center bg-no-repeat"
      :style="{ backgroundImage: `url('/what_${index + 1}.jpg')` }"
    />

    <!-- Gradient overlay - darker at bottom, dissolving to top -->
    <div v-if="isExpanded" class="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />

    <!-- Text content that appears only when expanded -->
    <div v-if="isExpanded" class="absolute bottom-0 left-0 text-white p-12 w-full z-10">
      <div class="text-left">
        <h3 class="sub-heading-1 mb-2">{{ getContent(index).title }}</h3>
        <p class="text-base opacity-90 leading-relaxed">{{ getContent(index).description }}</p>
      </div>
    </div>

    <slot />
  </div>
</template>

<script setup lang="ts">
interface Props {
  index: number
  isExpanded: boolean
}

interface Emits {
  (e: 'mouseenter', index: number): void
  (e: 'mouseleave'): void
}

defineProps<Props>()
defineEmits<Emits>()

// Content data for each item
const contentData = [
  {
    title: "Proudly recognized as Bali's Leading Tourism Activity Operator 2025–2026",
    description:
      "We bring you experiences that go beyond the ordinary, from thrilling adventures to serene escapes. Join thousands of happy travelers who've made us part of their Bali story."
  },
  {
    title: 'Certified Guides: Safe Adventures',
    description:
      'Every one of our rafting guides has successfully passed the official rafting navigation certification for the Ayung River, issued by the Bali Tourism Office and recognized by both FAJI (Indonesian Rafting Federation) and GAHAWISRI (Indonesian Marine Tourism Association).'
  },
  {
    title: 'Monthly Training for Our Rafting Guides',
    description:
      "Our rafting guides join monthly training sessions to stay sharp, safe, and ready for anything. From river rescue to guest care, we make sure every trip down the Ayung is led by someone who's skilled, confident, and passionate about your experience. Even though our rafting guides already know the Ayung River like the back of their hand, we believe there's always something new to learn whether it's perfecting paddle techniques, improving teamwork, or finding new ways to make our guests smile."
  },
  {
    title: 'Trusted by the Best. Chosen by Thousands.',
    description:
      "Leading travel agents and big-name companies count on us to deliver unforgettable Bali experiences. Whether you're booking solo or through a trusted partner, you're in great company."
  }
]

// Function to get content based on index
const getContent = (index: number) => {
  return contentData[index] || { title: `Feature ${index + 1}`, description: 'No description available' }
}
</script>
